import React, { useCallback, useEffect, useState, KeyboardEvent } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import "./login.css";
import { fetchLoginData, forgotPassword } from "../login/login.utils";
import Button from "../../widgets/button";
import { LOGIN_DIALOGS } from "../../constants/dialog.constants";
import { Link, useNavigate } from "react-router-dom";

import {
  APP_FOOTER,
  BUILD_PATH,
  FORGOT_PASSWORD_API,
  LOGIN_API,
} from "../../constants/app.constants";
import LoaderTrans from "../../widgets/loadertrans";
import TextField from "../../widgets/textField/textField";
import { SERVER_URL } from "../../constants/app.constants";
import { useMutation } from "@tanstack/react-query";

const Login: React.FC = () => {
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [forgotUserName, setForgotUserName] = useState("");
  const [errorMessageForgot, setErrorMessageForgot] = useState("");
  const [isForgotPasswordWindowOpen, setIsForgotPasswordWindowOpen] =
    useState(false);
  const [isResetPasswordWindowOpen, setIsResetPasswordWindowOpen] =
    useState(false);
  // const [isForgotPasswordSubmit, setIsForgotPasswordSubmit] = useState(false);
  const [isSuccessMailMessage, setIsSuccessMailMessage] = useState(false);

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const {
    isLoading: isLoadingUser,
    data: dataUser,
    isFetching,
    status,
  } = useQuery({
    queryKey: [LOGIN_API],
    queryFn: () => fetchLoginData(userName, password),
    enabled: isSubmit,
  });

  const forgotPasswordMutation = useMutation({
  mutationFn: (username: string) =>
    forgotPassword(username, SERVER_URL),

  onSuccess: (data) => {
    setForgotUserName("");

    if (data === "success") {
      setIsSuccessMailMessage(true);
      setErrorMessageForgot(LOGIN_DIALOGS.emailSuccess);
    } else if (data === "mailnotsent") {
      setIsSuccessMailMessage(false);
      setErrorMessageForgot(LOGIN_DIALOGS.problemSendingEmail);
    } else if (data === "notMatched") {
      setIsSuccessMailMessage(false);
      setErrorMessageForgot(LOGIN_DIALOGS.invalidFRGTDetails);
    }
  },

  onError: () => {
    setForgotUserName("");
    setIsSuccessMailMessage(false);
    setErrorMessageForgot(LOGIN_DIALOGS.technicalError);
  },
});




  const onChangeFieldValues = useCallback(
    (id: string, updatedValue: string) => {
      if (id === "userName") {
        setUsername(updatedValue);
      } else if (id === "passwordField") {
        setPassword(updatedValue);
      } else if (id === "forgotUserName") {
        setForgotUserName(updatedValue);
      }
    },
    [userName, password, forgotUserName]
  );

  const handleKeyPress = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        onSubmit();
      }
    },
    [userName, password]
  );

  const onSubmit = useCallback(() => {
    setErrorMessage("");
    if (userName === "" || password === "") {
      setErrorMessage(LOGIN_DIALOGS.emptyLoginDetails);
    } else if (userName !== "" && password !== "") {
      setIsSubmit(true);
    }
  }, [userName, password, isSubmit]);

  useEffect(() => {
    if (isSubmit && dataUser) {
      setIsSubmit(false);
      if (dataUser?.scriptError == "0") {
        const { ID, Name, Person_ID, QuickbookID, ContactName, ContactID } = JSON.parse(dataUser.scriptResult);

        const sessionExpiry = Date.now() + 60 * 60 * 1000; // 1 hour session
        
        window.localStorage.setItem("ID", ID);
        window.localStorage.setItem("Name", Name);
        window.localStorage.setItem("Person_ID", Person_ID);
        window.localStorage.setItem("Intake_QuickbooksAccount", QuickbookID);
          window.localStorage.setItem("Contact Name FL", ContactName);
         window.localStorage.setItem("_k_Contact_ID", ContactID);

        window.localStorage.setItem("session_expiry", sessionExpiry.toString());
        navigate(`/${BUILD_PATH}Overview`);
      } else {
        setErrorMessage(LOGIN_DIALOGS.loginFailed);
      }
      setUsername("");
      setPassword("");
      queryClient.removeQueries();
    } else if (isSubmit && status == "error") {
      setErrorMessage(LOGIN_DIALOGS.loginFailed);
      setUsername("");
      setPassword("");
    }
  }, [isSubmit, dataUser]);

  useEffect(() => {
    const url = window.location.href;
    if (url.includes("forgotpassword")) {
      setIsForgotPasswordWindowOpen(true);
    }
  }, [window]);

  const openForgotPasswordWindow = useCallback(() => {
    setIsForgotPasswordWindowOpen(true);
  }, [isForgotPasswordWindowOpen]);

  const openResetPasswordWindow = useCallback(() => {
    setIsResetPasswordWindowOpen(true);
  }, [isResetPasswordWindowOpen]);

  const cancelForgotPassword = useCallback(() => {
    setIsForgotPasswordWindowOpen(false);
    setErrorMessageForgot("");
    setForgotUserName("");
    setErrorMessage("");
  }, [isForgotPasswordWindowOpen]);

  const cancelResetPassword = useCallback(() => {
    setIsResetPasswordWindowOpen(false);
    setErrorMessageForgot("");
    setForgotUserName("");
    setErrorMessage("");
  }, [isResetPasswordWindowOpen]);

const setForgotPassword = useCallback(() => {
  setErrorMessageForgot("");
  setIsSuccessMailMessage(false);

  if (!forgotUserName) {
    setErrorMessageForgot(LOGIN_DIALOGS.fillDetailsFRGT);
    return;
  }

  forgotPasswordMutation.mutate(forgotUserName);
}, [forgotUserName]);




  return (
    <div className="loginBox">
      <div className="box">
        {isForgotPasswordWindowOpen ? (
          <div>
            <h1 className="h3 mb-3 font-weight-normal">Forgot Password</h1>
            {forgotPasswordMutation.isPending && (
  <LoaderTrans msg="Loading" />
)}

            <TextField
              id="forgotUserName"
              value={forgotUserName}
              onChange={onChangeFieldValues}
              onKeyPress={handleKeyPress}
              className="inputcls"
              type="email"
              placeholder="Enter your username"
            />
            <Button
              data="Cancel"
              type="submit"
              onClick={cancelForgotPassword}
              className="btnlogin btncancel"
            />
            <Button
              data="Continue"
              type="submit"
              onClick={setForgotPassword}
              className="btnlogin"
            />
            <div
              className={
                isSuccessMailMessage ? "successMsgStyle" : "errorMsgStyle"
              }
            >
              {errorMessageForgot}
            </div>
          </div>
        ) : (
          <div>
            <h1>WELCOME</h1>
            <p className="subtitle">Please sign in</p>
            <div className="frm">
              <TextField
                id="userName"
                value={userName}
                onChange={onChangeFieldValues}
                className="email inputcls"
                type="email"
                placeholder="Enter your Username"
                onKeyPress={handleKeyPress}
              />
              <TextField
                id="passwordField"
                value={password}
                onChange={onChangeFieldValues}
                className="pwd inputcls"
                type="password"
                placeholder="Enter your Password"
                onKeyPress={handleKeyPress}
              />
              <div>
                <Button
                  data="SIGN IN"
                  type="submit"
                  onClick={onSubmit}
                  className="btnlogin"
                />
              </div>
            </div>
            {isLoadingUser || isFetching ? (
              <div>
                <LoaderTrans msg="Signing In" />
              </div>
            ) : null}
            <div className="errorMsgStyle">{errorMessage}</div>
            <Link to="#" className="reset" onClick={openForgotPasswordWindow}>
              Forgot Password?
            </Link>
            <p className="copyright">{APP_FOOTER}</p>
          </div>
        )}
      </div>
    </div>
  );
};
export default Login;
